import {
    FETCH_ATTENDEE,
    FETCH_ATTENDEES,
    FETCH_TASKS,
    FETCH_ATTENDEESPRINT,
    FETCH_ATTENDEELEVELSHARE
} from '../actions/attendee';


export const initialState = {
    isFetching: true,
    data: null
};

export const attendees = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ATTENDEES}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ATTENDEES}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const attendeesprint = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ATTENDEESPRINT}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ATTENDEESPRINT}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const attendee = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ATTENDEE}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ATTENDEE}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.payload.data,
            });
        default:
            return state;
    }
}

export const tasks = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_TASKS}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_TASKS}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}
export const attendeeLevelShare = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_ATTENDEELEVELSHARE}_PENDING`:
            return Object.assign({}, initialState);
        case `${FETCH_ATTENDEELEVELSHARE}_SUCCESS`:
            return Object.assign({}, state, {
                isFetching: false,
                pagination: {
                    total: action.payload.total,
                    defaultPageSize: action.payload.pageSize,
                    current: action.payload.page,
                },
                searchParams: action.meta.searchParams,
                extra: action.meta.extra,
                data: action.payload.data,
            });
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/attendee.js